import React from 'react'
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import { useDashboardSourceDataContext } from '../../DashboardSourceDataProvider';

const ExitDialog = ({ isActive, closeDialog, scrollRef }) => {
    const {
        switchMode,
        dashboardUserNavStateLib
    } = useDashboardDomainContext();

    const { clearSourceDataCache } = useDashboardSourceDataContext();

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            title={"Exit Design Mode"}
            onOk={() => {
                closeDialog();
                switchMode("view");
                clearSourceDataCache();
                // Scrolling to account for new dashboard creation.
                dashboardUserNavStateLib.scrollToEndPostDashCreation(scrollRef);
            }}
            onCancel={() => {
                closeDialog();
            }}
            okText={"Exit"}
            cancelText={"Return"}
        >
            <div className="dialog-text">
                This dashboard has not been published yet. Click "Return" to continue designing or click "Exit" to leave without publishing.
            </div>
        </DialogControl>
    )
}

export default ExitDialog